import React from 'react'
import { SobreNosotrosUi } from '../../../../Desktop/componentsLogueado/ui/SobreNosotrosUi/SobreNosotrosUi'
import { Header } from '../../../../Desktop/componentsLogueado/layouts/Header/Header'

export const SobreNosotrosLayouts = () => {
  return (
    <div>
        <Header/>
        <SobreNosotrosUi/>
    </div>
  )
}
